import React, { useState } from "react";
import { Button, CircularProgress, Grid2, Stack } from "@mui/material";
import { asyncGetList } from "../../../../../utils/httpRequests";
import { useSelector } from "react-redux";
import ModalBase from "../../../modal/ModalBase";
import CheckboxInput from "../../../input/CheckboxInput";
import { groupBy } from "../../../../../utils/helpers";
import { cloneDeep, isArray } from "lodash";

function SocialCategories({
  currentRight,
  addOrUpdateRight,
}: {
  currentRight: any;
  addOrUpdateRight: (data: { [key: string]: any }) => void;
}) {
  const { token } = useSelector((state: any) => state.auth);
  const [parentCategories, setParentCategories] = useState<any[]>([]);
  const [childrenCategories, setChildrenCategories] = useState<{
    [key: string]: any[];
  }>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const getSocialCategories = async () => {
    setLoading(true);
    const resp = await asyncGetList({
      apiCode: "socialcategories",
      token,
      condition: { page: 1, limit: 999999 },
    });
    if (resp && resp?.status === 200) {
      const data = resp?.data || [];
      const parentData = [];
      const childrenData = [];
      for (let i = 0; i < data?.length; i++) {
        if (!data[i]?.parentId) {
          parentData.push(data[i]);
        } else {
          childrenData.push(data[i]);
        }
      }
      parentData.sort((a, b) => a.no - b.no);
      setParentCategories(parentData);
      const groupedData = groupBy({
        data: childrenData,
        callbackMatch: (item) => item.parentId,
        returnKey: true,
      });
      setChildrenCategories(groupedData as { [key: string]: any });
    }
    setLoading(false);
  };

  const handleSelectCategory = async (id: string) => {
    let ids: string[] = cloneDeep(currentRight?.viewOfOther_user_groups);
    if (ids.includes(id)) {
      ids = ids.filter((item) => item !== id);
    } else {
      ids.push(id);
    }
    await addOrUpdateRight({ viewOfOther_user_groups: ids });
  };

  const handleSelectParentCategory = async (
    parentId: string,
    checked: boolean
  ) => {
    let ids: string[] = cloneDeep(currentRight?.viewOfOther_user_groups);
    const subIds = (childrenCategories?.[parentId] || []).map(
      (item) => item._id
    );
    ids = ids.filter((item) => !subIds.includes(item));
    if (!checked) {
      ids.push(...subIds);
    }
    await addOrUpdateRight({ viewOfOther_user_groups: ids });
  };

  const handleOpenModal = () => {
    setOpenModal(true);
    getSocialCategories();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      {openModal && (
        <ModalBase
          title="Danh mục có quyền"
          open={openModal}
          handleClose={handleCloseModal}
          width="600px"
        >
          <Stack
            gap={2}
            sx={{
              px: 2,
              minHeight: "100px",
              maxHeight: "70vh",
              overflow: "auto",
            }}
          >
            {loading ? (
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress />
              </Stack>
            ) : (
              <>
                {parentCategories?.length > 0 &&
                  parentCategories.map((parent) => {
                    const subCategories =
                      childrenCategories?.[parent._id] || [];
                    const allChecked = subCategories.every((s) =>
                      (currentRight?.viewOfOther_user_groups || []).includes(
                        s?._id
                      )
                    );
                    return (
                      <Stack
                        key={parent?._id}
                        sx={{
                          p: 1,
                          border: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        <Stack direction="row" alignItems="center" gap={1}>
                          <CheckboxInput
                            label={parent?.name}
                            checked={allChecked}
                            onChange={() =>
                              handleSelectParentCategory(
                                parent?._id,
                                allChecked
                              )
                            }
                            wrapperSx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: 600,
                                color: "primary.main",
                              },
                            }}
                          />
                        </Stack>
                        {isArray(subCategories) &&
                          subCategories?.length > 0 && (
                            <Grid2 container spacing={2}>
                              {subCategories.map((sub) => {
                                const checked = (
                                  currentRight?.viewOfOther_user_groups || []
                                )?.includes(sub?._id);
                                return (
                                  <Grid2 key={sub._id} size={{ xs: 6 }}>
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      gap={1}
                                    >
                                      <CheckboxInput
                                        label={sub?.name}
                                        checked={checked}
                                        onChange={() => {
                                          handleSelectCategory(sub?._id);
                                        }}
                                      />
                                    </Stack>
                                  </Grid2>
                                );
                              })}
                            </Grid2>
                          )}
                      </Stack>
                    );
                  })}
              </>
            )}
          </Stack>
        </ModalBase>
      )}
      <Stack direction="row" justifyContent="flex-start">
        <Button
          onClick={handleOpenModal}
          variant="outlined"
          size="small"
          sx={{
            textTransform: "none",
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Danh mục có quyền
        </Button>
      </Stack>
    </>
  );
}

export default SocialCategories;
